!function () {
  'use strict';

  const selectors = {
    container: 'complementary-products',
    slides: '[data-complementary-slides]',
    slide: '[data-complementary-slide]',
    prev: '[data-complementary-prev]',
    next: '[data-complementary-next]',
    counter: '[data-complementary-counter]',
    nav: '[data-complementary-nav]',
  };

  function initSlider(container) {
    const slides = container.querySelectorAll(selectors.slide);
    const nav = container.querySelector(selectors.nav);
    if (!slides.length) return;

    if (slides.length <= 1) {
      if (nav) nav.hidden = true;
      return;
    }

    if (!nav || nav.dataset.complementaryReady === 'true') return;

    const prevBtn = nav.querySelector(selectors.prev);
    const nextBtn = nav.querySelector(selectors.next);
    const counter = nav.querySelector(selectors.counter);
    let current = 0;

    const showSlide = (index) => {
      current = (index + slides.length) % slides.length;

      slides.forEach((slide, i) => {
        slide.hidden = i !== current;
      });

      if (counter) {
        counter.textContent = `${current + 1}/${slides.length}`;
      }
    };

    nav.dataset.complementaryReady = 'true';
    nav.hidden = false;

    prevBtn.addEventListener('click', () => showSlide(current - 1));
    nextBtn.addEventListener('click', () => showSlide(current + 1));
    showSlide(0);
  }

  function initContent(container) {
    if (container.querySelector(selectors.slide)) {
      initSlider(container);
    }
  }

  class ComplementaryProducts extends HTMLElement {
    connectedCallback() {
      initContent(this);

      const url = this.getAttribute('data-url');
      if (!url) return;

      new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;

          observer.unobserve(this);

          fetch(url)
            .then((response) => response.text())
            .then((html) => {
              const wrapper = document.createElement('div');
              wrapper.innerHTML = html;
              const content = wrapper.querySelector(selectors.container);

              if (content && content.innerHTML.trim().length) {
                this.innerHTML = content.innerHTML;
                initContent(this);
              }
            })
            .catch((error) => console.error(error));
        },
        { rootMargin: '0px 0px 400px 0px' }
      ).observe(this);
    }
  }

  if (!customElements.get('complementary-products')) {
    customElements.define('complementary-products', ComplementaryProducts);
  }
}();
